module.exports = __webpack_public_path__ + "static/media/trending_hero_tablet.7d6474cf.png";